import gsap from 'gsap';
import type { RefObject } from 'react';
import type { CtaRefType } from 'util/cta/cta.data';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';

interface PlayButtonRefs {
  elementRef: RefObject<CtaRefType | null>;
  labelRef: RefObject<HTMLSpanElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PlayButtonRefs,
): void {
  timeline.fromTo(
    elementRef.current,
    { scale: 0.4 },
    { duration: 0.5, scale: 1, ease: 'Expo.easeOut' },
    0,
  );
  timeline.add(fadeFromTo(elementRef.current as HTMLElement), 0);

  // if (labelRef?.current) {
  //   timeline.fromTo(labelRef.current, { scale: 4 }, {
  //     scale: 1,
  //     clearProps: 'scale',
  //     ease: 'Expo.easeOut',
  //     duration: 0.5,
  //   }, 0);
  // }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PlayButtonRefs,
): void {
  timeline.add(
    fadeTo(elementRef.current as HTMLElement, {
      duration: 0.4,
      ease: 'Expo.easeOut',
    }),
  );
  timeline.to(elementRef.current, { duration: 0.4, scale: 0.4, ease: 'Expo.easeOut' }, 0);
}

export function mouseLeaveAnimation({
  backgroundHoverRef,
  labelRef,
}: {
  backgroundHoverRef: RefObject<HTMLDivElement | null>;
  labelRef: RefObject<HTMLSpanElement | null>;
}): void {
  gsap.killTweensOf(backgroundHoverRef.current);
  gsap.killTweensOf(labelRef.current);

  gsap.to(backgroundHoverRef.current, 0.4, {
    ease: 'Power3.easeOut',
    y: '-75%',
  });
  gsap.to(labelRef.current, 0.4, {
    ease: 'Expo.easeOut',
    scale: 1,
  });
}

export function mouseEnterAnimation({
  backgroundHoverRef,
  labelRef,
}: {
  backgroundHoverRef: RefObject<HTMLDivElement | null>;
  labelRef: RefObject<HTMLSpanElement | null>;
}): void {
  gsap.killTweensOf(backgroundHoverRef.current);
  gsap.killTweensOf(labelRef.current);

  gsap.to(backgroundHoverRef.current, 0.5, {
    ease: 'Power3.easeOut',
    startAt: { y: '75%' },
    y: '0%',
  });
  gsap.to(labelRef.current, 0.4, {
    ease: 'Expo.easeOut',
    scale: 0.8,
  });
}
